import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { AuctionBoard } from "./auctions-shared";

/**
 * Live auction + Buy It Now board for one printed Palworld card code.
 * Public and read-only: it is the same marketplace data the card's eBay links
 * lead to, surfaced on Pal Stars so a reader does not have to leave to see it.
 */
export const getCardAuctions = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => z.object({ code: z.string().min(3).max(24) }).parse(data))
  .handler(async ({ data }): Promise<AuctionBoard> => {
    const { readCardAuctions } = await import("./auctions.server");
    return await readCardAuctions(data.code);
  });
